import { Request } from './Request';

export interface IGetMastheadNotificationsParams {
}

export interface IGetMastheadNotificationsResult {
  contentUrl: string;
}

export class GetMastheadNotificationsRequest
    extends Request<IGetMastheadNotificationsParams, IGetMastheadNotificationsResult> {

  constructor() {
    super('getMastheadNotifications', {});
  }

}
